/* =========================================================
   Carrinho lateral — Zavanni
   1) Qualquer link "/cart" abre a gaveta do carrinho.
   2) O "Ver carrinho" do pop-up de produto adicionado
      apenas fecha o pop-up, porque a gaveta já está aberta atrás.
   ========================================================= */

(function () {
  var POPUP = 'quick-buy-drawer';

  /* ---------- 1. Links "/cart" abrem a gaveta ---------- */
  function fix() {
    document.querySelectorAll('a[href="/cart"], a[href$="/cart"]').forEach(function (link) {
      // links dentro do pop-up ficam de fora: eles só fecham o pop-up
      if (link.closest(POPUP)) {
        link.removeAttribute('aria-controls');
        link.dataset.popupClose = '1';
        return;
      }

      if (link.dataset.drawerReady) return;

      link.dataset.drawerReady = '1';
      link.setAttribute('aria-controls', 'cart-drawer');
      link.setAttribute('data-no-instant', '');
    });
  }

  document.addEventListener('DOMContentLoaded', fix);
  new MutationObserver(fix).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
  fix();

  /* ---------- 2. "Ver carrinho" dentro do pop-up ---------- */
  function closePopup(popup) {
    var closeBtn =
      (popup.shadowRoot &&
        popup.shadowRoot.querySelector('[part="outside-close-button"], [part="close-button"]')) ||
      popup.querySelector('[is="close-button"]');

    if (closeBtn) {
      closeBtn.click();
      return;
    }

    if (typeof popup.close === 'function') {
      popup.close();
      return;
    }

    popup.removeAttribute('open');
    popup.style.display = 'none';
  }

  function openDrawerIfClosed() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (drawer.hasAttribute('open') || drawer.classList.contains('is-open')) return;

    if (typeof drawer.show === 'function') {
      drawer.show();
      return;
    }

    var icon = document.querySelector('[aria-controls="cart-drawer"]:not([href]):not([data-popup-close])');
    if (icon) icon.click();
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('a[href="/cart"], a[href$="/cart"]');
      if (!link) return;

      var popup = link.closest(POPUP);
      if (!popup) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      link.removeAttribute('aria-controls');
      closePopup(popup);

      setTimeout(openDrawerIfClosed, 150);
    },
    true
  );
})();